import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindCatalogueLandingV2Content
{
  queryCatalogueLandingV2Contents {
    data {
      pageTitle { iv }      

      intro {
        iv{id}
      }

      carrousel {
        iv{id}
      }
      
      nouveautesCatalogue {
        iv{id}
      }

      universeTitle { iv }
      universeFontSizeTitle { iv }
      description { iv }
      descriptionFontSize { iv }
      descriptionTextColor { iv }
      universeImageList: imageList {
        iv{
          picture{
              url
              fileSize
          }
          text
          pictureLink
          highlight
        }
      }

      brandTitle { iv }
      brandDescription { iv }
      brandDescriptionFontSize { iv }
      brandDescriptionTextColor { iv }
      brandImageList {
        iv{
          picture{
              url
              fileSize
          }
          text
          pictureLink
        }
      }
      brandCtaText { iv }
      brandCtaLink { iv }
      brandCtaStyle { iv }

      actualite {
        iv{id}
      }
      
      tendance {
        iv{id}
      }

      promo {
        iv{id}
      }

      seoDescription { iv }
      seoKeywords { iv }
      seoThumbnail {
        iv {
          url
        }
      }
    }
  }
}
`,
]);
